<template>
  <div>
    <el-menu class="navbar" mode="horizontal" :background-color="theme.headerColor">
      <div class="logo" :class="[{'collapse':isCollapse},device]">
        <router-link class="img" to="/dashboard"><img class="vcenter" :src="logo"></router-link>
      </div>  
      <hamburger :class="device" :toggle-click="toggleSideBar" :is-active="sidebar.opened" class="hamburger-container"/>
      <p class="title" :class="device" :style="{'color':textColor}">{{title}}</p>
      <!-- <breadcrumb /> -->
      
      <el-dropdown class="avatar-container" :show-timeout="100" placement="bottom">
        <div class="avatar-wrapper">
          <span class="userName" :style="{'color':textColor}">{{currentName}}</span>
          <img v-if="avatar!==null&&avatar!==''" :src="avatar" class="user-avatar" style="margin-top:3px">
          <svg-icon class="user-avatar" icon-class="user" v-else></svg-icon>
        </div>
        <el-dropdown-menu slot="dropdown" class="user-dropdown">
          <el-dropdown-item @click.native="goSetting">
            {{$t('buttons.setting')}}
          </el-dropdown-item>
          <el-dropdown-item @click.native="handleManage" v-if="$store.state.user.permission.indexOf(5)!==-1">
            <span style="display:block;">{{$t('buttons.manage')}}</span>
          </el-dropdown-item>
          <!-- <el-dropdown-item @click.native="handleAbout">
            <span style="display:block;">{{$t('buttons.about')}}</span>
          </el-dropdown-item> -->
          <el-dropdown-item @click.native="checkLogout">
            <span style="display:block;">{{$t('buttons.logOut')}}</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <!-- <theme-picker class="themeBar"></theme-picker> -->
      <screenfull :style="{'color':textColor}" class="screenfull right-menu-item"></screenfull>
      <lang-select style="float:right;margin-right:15px"/>
      <theme-bar :themeStyle="{'color':textColor}" style="margin-top:0" class="themeBar"/>
      <information ref="information"></information>
    </el-menu>
    <el-dialog
      v-el-drag-dialog
      class="aboutDialog"
      append-to-body
      :visible.sync="aboutVisible"
      width="700px">
      <template slot="title">
        <div>
          <svg-icon icon-class="copyright"/>
          <span class="header">版本</span>          
        </div>
      </template>
      <div class="logo">
        <img :src="aboutLogo" alt="">
        <div class="right">
          <span style="font-size:14px;letter-spacing:1.5px;margin-top:-5px">Workfine</span>
          <span style="font-size:16px;font-weight:600;letter-spacing:8px">成就数字企业</span>
        </div>
      </div>
      <div style="padding:0 30px">
        <el-form>
          <el-form-item label="产品版本:">
            <span>V{{licenses.productVersion}}</span>
          </el-form-item>
          <el-form-item label="授权单位:">
            <span>{{licenses.to}}</span>
          </el-form-item>
          <el-form-item label="授权期限:">
            <span>{{time(licenses.expiryDate)}}</span>
          </el-form-item>
        </el-form>
        <p style="margin-bottom:20px">
          本软件由无锡柏思科技有限公司独立开发，本软件的版权属于无锡柏思科技有限公司，未经无锡柏思科技有限公司的授权许可，不得擅自发布或使用该软件。
        </p>
        <p>
          警告：本计算机程序受著作权法和国际公约的保护，未经授权擅自复制或散布本程序的部分或全部，将承受严厉的民事和刑事处罚，对已知的违反者将给予法律范围内的全面制裁。
        </p>
        <p class="copyright">
          Copyright © 2017-{{parseTime(new Date(),'{y}')}} Wuxi BossieTech Co.,Ltd. All Rights Reserved.
        </p>
      </div>
      
    </el-dialog>
  </div>
  
</template>

<script>
import { parseTime } from '@/utils'
import { getLicenses } from '@/api/license'
import LangSelect from '@/components/LangSelect'
import aboutLogo from '@/assets/images/logo.png'
import { mapGetters } from 'vuex'
import Information from './Information'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import Screenfull from '@/components/Screenfull'
import ThemePicker from '@/components/ThemePicker'
import ThemeBar from './ThemeBar'
import {
  getWorkStationSettings,
  getWorkStationLogo
} from '@/api/login'
export default {
  components: {
    Breadcrumb,
    Hamburger,
    Screenfull,
    ThemePicker,
    Information,
    ThemeBar,
    LangSelect
  },
  computed: {
    ...mapGetters([
      'device',
      'name',
      'sidebar',
      'avatar',
      'backgroundColor',
      'textColor',
      'activeTextColor',
      'logoBackgroundColor',
      'currentName',
      'theme'
    ]),
    isCollapse() {
      return !this.sidebar.opened
    },
    devMode() {
      return process.env.NODE_ENV === 'development'
    }
  },
  created() {
    getWorkStationSettings().then(response => {
      this.title = response.data.name
      document.title = this.title
    }).catch((exception) => {
      console.error('系统名称获取失败！' + (exception.response.status !== 500 ? exception.response.data : '未知错误'))
    })
    this.logo = `${process.env.BASE_API}/solutions/${localStorage.getItem('client-solutionId')}/images?key=4`
  },
  data() {
    return {
      parseTime: parseTime,
      licenses: {},
      aboutVisible: false,
      aboutLogo: aboutLogo,
      logo: undefined,
      title: '企业业务数字化开发平台'
    }
  },
  methods: {
    time(str) {
      if (str !== undefined) {
        if (str === null) {
          return '无期限'
        } else {
          return str.replace('T00:00:00', '')
        }
      }
    },
    getLicenses() {
      getLicenses().then(response => {
        this.licenses = response.data
      })
    },
    handleAbout() {
      this.aboutVisible = true
      this.getLicenses()
    },
    handleManage() {
      const view = {
        path: '/manage',
        meta: { name: this.$t('buttons.manage'), title: 'manage' }
      }
      this.$store.dispatch('SetLastTab', view)
      this.$store.dispatch('addView', view)
      this.$router.push('/manage')
    },
    goSetting() {
      const view = {
        path: '/setting',
        meta: { name: this.$t('buttons.setting'), title: 'setting' }
      }
      this.$store.dispatch('SetLastTab', view)
      this.$store.dispatch('addView', view)
      this.$router.push('/setting')
    },
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    checkLogout() {
      this.$confirm(this.$t('alert.isLogOut'), this.$t('status.warning'), {
        confirmButtonText: this.$t('buttons.confirm'),
        cancelButtonText: this.$t('buttons.cancel'),
        type: 'warning',
        center: true
      })
        .then(() => {
          window.onbeforeunload = () => {}
          this.logout()
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消'
          // })
        })
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        this.$refs.information.connection.stop()
        window.location.href = window.location.origin
        // location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    }
  }
}
</script>

<style lang="scss">
.aboutDialog{
  .el-form{
    margin-bottom: 40px;
  }
  .el-form-item__content,.el-form-item__label{
    line-height: 24px !important;
    color:#4d4d4d;
  }
  .el-form-item{    
    margin-bottom: 0 !important;
  }
  p{
    color:#4d4d4d;
    margin-bottom: 30px;
    font-size: 14px;
  }
  p.copyright{
    color:rgba(77,77,77,0.4);
  }
  .el-dialog__body{
    padding:30px !important;
  }
  .el-dialog__header{
    background: #f5f5f5;
  }
  .svg-icon{
    color:rgba(77,77,77,0.5);
    margin-top: -3px;
  }
  .header{
    font-size: 14px;
    color:rgba(77,77,77,0.5);
  }
  .logo{
    padding-left: 30px;
    overflow: hidden;
    padding-bottom: 30px;
    border-bottom: 1px solid #ebebeb;
    margin-bottom: 30px;
    img{
      float: left;
    }
    .right{
      float: left;
      height: 35px;
      margin-left: 10px;
      padding-left: 10px;
      border-left: 2px solid #1191f3;
      span{
        // margin-top: -2px;
        display: block;
        color:#000;
        font-family: SourceHanSansCn;
      }
    }
  }
}
  
</style>
<style rel="stylesheet/scss" lang="scss" scoped>

.hideSidebar{
  .hamburger-container{
    margin-left: 0px !important;
  }
 
}

.navbar {
  transition: 0.3s;
  position: relative;
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  .title.mobile{
    padding: 0;
  }
  .hamburger-container.mobile{
    margin-left: 0px !important;
  }
  .logo{
    transition: 0.28s;
    width: 270px;
    height: 100%;
    float: left;    
    a.img{
      display: block;
      width: 100%;
      height: 100%;
      position: relative;
      overflow: hidden;
    }
  }
  .logo.mobile{
    display: none;
  }
  .logo.collapse{
    opacity: 0;
    width: 0;
  }
  .hamburger-container {
    position: relative;
    line-height: 58px;
    height: 49px;
    float: left;
    margin-left: -48px;
    padding: 0 10px;
    color:#fff;
    z-index: 1001;    
  }
  .screenfull {
    float: right;
    margin-right: 10px;
  }
  .themeBar{
    float: right;
    margin-top: 11px;
    margin-right: 10px;
  }
  .avatar-container {
    height: 50px;
    float: right;
    margin-right: 20px;
    span.userName{
      line-height: 50px;
      float: left;
      margin-right: 5px;
    }
    .avatar-wrapper {
      float: left;
      cursor: pointer;
      height: 50px;
      position: relative;
      .user-avatar {
        width: 42px;
        height: 42px;
        border-radius: 50%;
        color:#fff;
      }
      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 15px;
        font-size: 12px;
      }
    }
  }
  .title{
    padding-left: 20px;
    color:inherit;
    float: left;
    font-size:16px;
  }
}
</style>

